var map = {
	"./campaign-logo-alphabet.svg": 549,
	"./campaign-logo-amazon.svg": 550,
	"./campaign-logo-bank-of-america.svg": 551,
	"./campaign-logo-barclays.svg": 552,
	"./campaign-logo-bnp-paribas.svg": 553,
	"./campaign-logo-coca-cola.svg": 554,
	"./campaign-logo-goldman-sachs.svg": 555,
	"./campaign-logo-hsbc.svg": 528,
	"./campaign-logo-ikea.svg": 556,
	"./campaign-logo-jp-morgan.svg": 557,
	"./campaign-logo-meta.svg": 558,
	"./campaign-logo-morgan-stanley.svg": 559,
	"./campaign-logo-oracle.svg": 560,
	"./campaign-logo-pwc.svg": 561,
	"./campaign-logo-walmart.svg": 562
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1329;